import React, {useContext, useEffect, useState} from "react";

import {log, logMetric} from "../../ApiCalls";

import "../../../../style/PriorityTableStyles/actionButton.css";

import {ActionButtonModeEnum} from "../../../../Types/ActionButtonMode"
import {StatusEnum} from "../../../../Types/StatusEnum";
import {RolesEnum} from "../../../../Types/RolesEnum";
import SetToReviewModal from "./SetToReviewModal";
import RevisionModal from "./RevisionModal";
import ContentEditorApproveModal from "./ContentEditorApproveModal";
import {TaskType} from "../../../../Types/Task";
import {azureTokenContext, userIdContext} from "../../../../App";
import {makeMetricPayloadByPriorityNumber} from "../OpenDocumentDropdown";

export default function ActionButton({task, setAllTasks, setSelectedTasks}: {
    task: TaskType,
    setAllTasks: React.Dispatch<React.SetStateAction<TaskType[]>>,
    setSelectedTasks: React.Dispatch<React.SetStateAction<TaskType[]>>
}) {
    const userId = useContext(userIdContext);
    const azureToken = useContext(azureTokenContext);

    const [buttonMode, setButtonMode] = useState<ActionButtonModeEnum>(ActionButtonModeEnum.none);
    const [isSetToReviewModalOpen, setIsSetToReviewModalOpen] = useState(false);
    const [isContentEditorApproveModalOpen, setIsContentEditorApproveModalOpen] = useState(false);
    const [isRevisionModalOpen, setIsRevisionModalOpen] = useState(false);

    useEffect(() => {
        if (!task.WorkItemId && !task.AuthorCreatedWI) {
            setButtonMode(ActionButtonModeEnum.update)
        } else if (task.Status === StatusEnum.init && task.Role === RolesEnum.author) {
            setButtonMode(ActionButtonModeEnum.setToReview)
        } else if (task.Status === StatusEnum.init && task.Role === RolesEnum.contentEditor && task.AuthorEmail) {
            setButtonMode(ActionButtonModeEnum.emailToAuthor)
        } else if (task.Status === StatusEnum.readyForReview && task.Role === RolesEnum.contentEditor && !task.GotApprovalFromContentReviewer) {
            setButtonMode(ActionButtonModeEnum.contentEditorApprove)
        } else {
            setButtonMode(ActionButtonModeEnum.none)
        }

    }, [task.Role, task.Status, task.WorkItemId, task.AuthorEmail, task.GotApprovalFromContentReviewer, task.AuthorCreatedWI]);

    const mailtoAuthorLink = () => {
        const authorEmail = task.AuthorEmail;
        const subject = encodeURIComponent(`Karnov - ${task.TaskName}`);
        const body = encodeURIComponent(`Hei, ${task.Author || "forfatter"}!\n\nDet er flott om du logger deg inn i Karnovs forfatterportal og følger opp oppgaven(e) knyttet til ditt manus til "${task.TaskName}". Ta gjerne kontakt med meg hvis du trenger hjelp. Du kan også kontakte redaksjonen (redaksjonen@karnovgroup.no) eller support (support@karnovgroup.no).\n\nVennlig hilsen\nFagredaktør, Karnov`);
        return `mailto:${authorEmail}?subject=${subject}&body=${body}`;
    }

    const logClickOnEmailToAuthorButton = () => {
        log("INFO", `ContentEditor clicked on email to author button for WorkItemId: ${task.WorkItemId}`, "AuthorsPortal", task.WorkItemId, "ContentEditor", userId, azureToken);
        const payload = makeMetricPayloadByPriorityNumber(task.PriorityNumber);
        logMetric("AuthorsPortal", "ContentEditor clicked on email to author button", "Success", "", "ContentEditor clicked on email to author button", task.WorkItemId, "ContentEditor", userId, azureToken, payload);
    }

    return (
        <div className="action-button-container">
            {buttonMode === ActionButtonModeEnum.none && <></>}
            {buttonMode === ActionButtonModeEnum.update &&
                <>
                    {task.Role === RolesEnum.author && (
                        <button
                            className="action-button"
                            onClick={() => setIsRevisionModalOpen(true)}
                        >
                            Oppdater
                        </button>
                    )}
                </>
            }
            {buttonMode === ActionButtonModeEnum.setToReview &&
                <button className="action-button" onClick={() => setIsSetToReviewModalOpen(true)}>Sett til
                    vurdering</button>
            }
            {buttonMode === ActionButtonModeEnum.contentEditorApprove &&
                <button className="action-button" onClick={() => setIsContentEditorApproveModalOpen(true)}>Godkjenn
                    manus</button>
            }
            {buttonMode === ActionButtonModeEnum.emailToAuthor &&
                <a href={mailtoAuthorLink()} onClick={logClickOnEmailToAuthorButton}>
                    <button className="action-button">Purr på forfatter</button>
                </a>
            }

            <SetToReviewModal isOpen={isSetToReviewModalOpen}
                              setIsOpen={setIsSetToReviewModalOpen}
                              task={task}
                              setAllTasks={setAllTasks}
                              setSelectedTasks={setSelectedTasks}
            />
            <ContentEditorApproveModal isOpen={isContentEditorApproveModalOpen}
                                       setIsOpen={setIsContentEditorApproveModalOpen}
                                       task={task}
                                       setAllTasks={setAllTasks}
                                       setSelectedTasks={setSelectedTasks}
            />

            <RevisionModal
                isOpen={isRevisionModalOpen}
                setIsOpen={setIsRevisionModalOpen}
                task={task}
                setAllTasks={setAllTasks}
                setSelectedTasks={setSelectedTasks}
            />
        </div>
    );

}
